export const ALL_CLASSES = 'all-classes';
